import * as React from 'react';

import { Alert, AlertTitle, Box, Button } from '@mui/material';

interface Props {
  title: string;
  description: string;
  reportUid: string;
  onGoToReportsQa: () => void;
  /** Request flow only: clear the form and start from scratch. */
  onStartNew?: () => void;
  onClose: () => void;
}

/** Confirmation shown above the form, which stays filled in so a similar report is one edit away. */
const SubmittedBanner: React.FC<Props> = ({
  title,
  description,
  reportUid,
  onGoToReportsQa,
  onStartNew,
  onClose,
}) => (
  <Alert severity="success" role="status" onClose={onClose}>
    <AlertTitle>{title}</AlertTitle>
    {description} Report UID <code>{reportUid}</code>.
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
      <Button
        size="small"
        variant="contained"
        color="success"
        onClick={onGoToReportsQa}
      >
        Go to Reports QA
      </Button>
      {onStartNew && (
        <Button size="small" color="success" onClick={onStartNew}>
          Start a new request
        </Button>
      )}
    </Box>
  </Alert>
);

export default SubmittedBanner;
